<template>
  <div class="pv-date-field">
    <v-menu
      :close-on-content-click="false"
      class="pv-date-field__menu"
      max-width="290px"
      offset-y
      transition="scale-transition"
      v-if="edit"
      v-model="open"
    >
      <template #activator="{ on, attrs }">
        <v-text-field
          :value="formattedValue"
          :rules="rules"
          :clearable="clearable"
          hide-details="auto"
          readonly
          @click:clear="$emit('input', null)"
          v-bind="attrs"
          v-on="on"
        />
      </template>
      <v-date-picker
        :value="pickerValue"
        :locale="$i18n.locale"
        no-title
        scrollable
        :header-date-format="headerFormat"
        :day-format="dayFormat"
        @input="onPick"
      />
    </v-menu>
    <span v-else>{{ formattedValue }}</span>
  </div>
</template>

<script>
import { isValid, parse } from 'date-fns';
import dateTimeFormatting from '@/mixins/dateTimeFormatting';

export default {
  name: 'pv-date-field',
  mixins: [dateTimeFormatting],
  props: {
    edit: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Array,
      default() {
        return [];
      },
    },
    value: {
      default: null,
    },
    format: {
      type: String,
      default: 'yyyy-MM-dd',
    },
    displayFormat: {
      type: String,
      default: 'yyyy/MM/dd',
    },
    clearable: Boolean,
  },
  computed: {
    formattedValue() {
      return this.value && this.formatLocalized(this.value, this.displayFormat);
    },
    pickerValue() {
      if (!this.value) {
        return null;
      }
      return isValid(parse(this.value, this.format, new Date()))
        ? this.formatLocalized(this.value, this.format)
        : null;
    },
  },
  data() {
    return {
      open: false,
    };
  },
  methods: {
    dayFormat(date) {
      return this.formatLocalized(date, 'd');
    },
    headerFormat(date) {
      return this.formatYearMonth(date);
    },
    onPick(value) {
      this.open = false;
      this.$emit('input', this.formatLocalized(value, this.format));
    },
  },
  watch: {
    edit() {
      this.open = false;
    },
  },
};
</script>

<style scoped lang="sass">
.pv-date-field
  ::v-deep .v-text-field
    margin: -6px 0 -5px
    padding: 0

    .v-input__slot
      border: 1px solid
      margin-bottom: 0

    input
      padding-left: 4px
      padding-right: 4px
      color: #666!important
</style>
